<div class="position-relative">
  <div [style.max-height]="contentMaxHeight" class="overflow-hidden">
    <ng-content></ng-content>
  </div>
  <div *ngIf="limitExceeded && !extended" class="position-absolute fade-overlay"></div>
</div>
<div *ngIf="limitExceeded">
  <span
    (click)="toggleExtend()"
    (keydown)="toggleExtend()"
    *ngIf="showMoreOption"
    [id]="generateId()"
    class="btn btn-link p-0 m-0"
    tabindex="0"
  >{{(extended ? 'common.less' : 'common.more') | cxTranslate}}</span>
</div>
